
export function arabicToRoman(num: number): string {
  if (num < 1) {
    throw "Invalid number. Number must be greater than 0.";
  }

  const lookup: Record<number, string> = {
    10: 'X', 9: 'IX', 5: 'V', 4: 'IV', 1: 'I',
    100: 'C', 90: 'XC', 50: 'L', 40: 'XL',
    1000: 'M', 900: 'CM', 500: 'D', 400: 'CD',
    10000: 'X̅', 9000: 'MX̅', 5000: 'V̅', 4000: 'MV̅',
    1000000: 'M̅', 900000: 'C̅M̅', 500000: 'D̅', 400000: 'C̅D̅', 100000: 'C̅', 90000: 'X̅C̅', 50000: 'L̅', 40000: 'X̅L̅',
    10000000: 'X̅̅', 9000000: 'M̅X̅̅', 5000000: 'V̅̅', 4000000: 'M̅V̅̅',
  };

  let roman = '';
  const keys = Object.keys(lookup)
    .map(k => parseInt(k))
    .sort((a, b) => b - a);

  for (const key of keys) {
    while (num >= key) {
      roman += lookup[key];
      num -= key;
    }
  }

  return roman;
}

